document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('dailyToggle');
  const labelSpan = document.getElementById('toggleLabel');
  const customAdd = document.getElementById('customAddToCart');
  const deliveryMsg = document.getElementById('deliveryMessage');
  const deliveryMsgTx = document.getElementById('deliveryMessageText');
  const nativeAdd = document.querySelector('button.add-to-cart');
  const paymentButton = document.querySelector('[data-shopify="payment-button"]');

  const hiddenSP = document.getElementById('sellingPlanInput') ||
                   document.querySelector('input[name="selling_plan"]') ||
                   document.querySelector('[data-sls-selling_plan]');

  if (toggle) toggle.checked = false;

  const priceData = JSON.parse(document.getElementById('variant-prices-data').textContent);
  const IS_UK = priceData.isUkMarket;

  const currencyConfigEl = document.getElementById('currency-config-data');
  const CURRENCY_CONFIG = currencyConfigEl
    ? JSON.parse(currencyConfigEl.textContent)
    : { isoCode: 'EUR', symbol: '€' };

  const i18nEl = document.getElementById('subscription-i18n-data');
  const I18N = i18nEl
    ? JSON.parse(i18nEl.textContent)
    : {
        monthlyPrice: 'Monthly price',
        dailyPrice: 'Daily price',
        thenPrefix: 'Then ',
        offOngoingSuffix: '% off ongoing',
        discount1stSuffix: '% OFF 1ST',
        discountOffSuffix: '% OFF',
        kidLabel: '/kid',
        quarterLabel: ' /quarter',
        tryNow: 'Try now',
        alertSubscriptionRequired: 'This product requires a subscription plan. Please select a subscription option.'
      };

  const CURRENCY_FORMATS = {
    'EUR': { symbolPosition: 'before', decimalSeparator: ',', thousandsSeparator: '.', symbolSpace: false },
    'GBP': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false },
    'CHF': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: "'", symbolSpace: true },
    'DKK': { symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: '.', symbolSpace: true },
    'SEK': { symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: ' ', symbolSpace: true },
    'NOK': { symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: ' ', symbolSpace: true },
    'USD': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false },
    'CAD': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false },
    'AUD': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false },
    'MXN': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false },
    'BRL': { symbolPosition: 'before', decimalSeparator: ',', thousandsSeparator: '.', symbolSpace: true },
    'JPY': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false, decimals: 0 },
    'PLN': { symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: ' ', symbolSpace: true },
    'CZK': { symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: ' ', symbolSpace: true },
    'TRY': { symbolPosition: 'after', decimalSeparator: ',', thousandsSeparator: '.', symbolSpace: true },
    'ZAR': { symbolPosition: 'before', decimalSeparator: '.', thousandsSeparator: ',', symbolSpace: false }
  };

  const CURRENCY_SYMBOLS = {
    'EUR': '€', 'USD': '$', 'GBP': '£', 'JPY': '¥', 'CHF': 'CHF',
    'CAD': '$', 'AUD': '$', 'NZD': '$', 'MXN': '$', 'BRL': 'R$',
    'DKK': 'kr.', 'SEK': 'kr', 'NOK': 'kr', 'PLN': 'zł', 'CZK': 'Kč',
    'TRY': '₺', 'ZAR': 'R', 'INR': '₹', 'SGD': '$', 'HKD': '$'
  };

  function getCurrentFormat() {
    return CURRENCY_FORMATS[CURRENCY_CONFIG.isoCode] || {
      symbolPosition: 'before',
      decimalSeparator: '.',
      thousandsSeparator: ',',
      symbolSpace: false,
      decimals: 2
    };
  }

  function getCurrentSymbol() {
    if (CURRENCY_CONFIG.symbol && CURRENCY_CONFIG.symbol !== '') return CURRENCY_CONFIG.symbol;
    return CURRENCY_SYMBOLS[CURRENCY_CONFIG.isoCode] || CURRENCY_CONFIG.isoCode;
  }

  function formatPrice(cents) {
    const format = getCurrentFormat();
    const symbol = getCurrentSymbol();
    const decimals = format.decimals !== undefined ? format.decimals : 2;
    const price = cents / 100;
    const [intPart, decPart] = price.toFixed(decimals).split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, format.thousandsSeparator);
    const formattedNumber = decimals > 0 ? formattedInt + format.decimalSeparator + decPart : formattedInt;
    const space = format.symbolSpace ? ' ' : '';
    return format.symbolPosition === 'after'
      ? formattedNumber + space + symbol
      : symbol + space + formattedNumber;
  }

  let currentVariantId = null;
  let currentNumKids = 1;

  function detectNumKids(variantTitle) {
    const title = String(variantTitle || '').toLowerCase();
    if (title.includes('5 kid')) return 5;
    if (title.includes('4 kid')) return 4;
    if (title.includes('3 kid')) return 3;
    if (title.includes('2 kid')) return 2;
    return 1;
  }

  function getQuarterlyCartUnits() {
    return Math.max(1, currentNumKids * 3);
  }

  function updateTabUnits() {
    const monthlyTab = document.querySelector('.subscription-tab.has-discount:not([data-plan-type="quarterly"])');
    const quarterlyTab = document.querySelector('.subscription-tab[data-plan-type="quarterly"]');
    const onetimeTab = document.querySelector('.subscription-tab--onetime');

    if (monthlyTab) monthlyTab.dataset.units = '1';
    if (onetimeTab) onetimeTab.dataset.units = '1';
    if (quarterlyTab) quarterlyTab.dataset.units = String(getQuarterlyCartUnits());
  }

  function updateAllPrices(variantId) {
    const variant = priceData.variants.find(v => String(v.id) === String(variantId));
    if (!variant) return;

    currentVariantId = variantId;
    currentNumKids = detectNumKids(variant.title);

    const basePrice = variant.price;
    const pricePerKid = basePrice / currentNumKids;

    let monthlyPrice = basePrice;
    let firstOrderDiscount = 0;

    const monthlyAllocation = variant.sellingPlanAllocations.find(
      a => String(a.sellingPlanId) === String(priceData.monthlyPlanId)
    );

    if (monthlyAllocation) {
      monthlyPrice = monthlyAllocation.price;
      if (basePrice > 0) firstOrderDiscount = Math.round((1 - monthlyPrice / basePrice) * 100);
    } else if (variant.sellingPlanAllocations.length > 0) {
      const fallbackAlloc = variant.sellingPlanAllocations[0];
      monthlyPrice = fallbackAlloc.price;
      if (basePrice > 0) firstOrderDiscount = Math.round((1 - monthlyPrice / basePrice) * 100);
      const subTab = document.querySelector('.subscription-tab.has-discount:not([data-plan-type="quarterly"])');
      if (subTab) subTab.dataset.plan = fallbackAlloc.sellingPlanId;
    }

    if (firstOrderDiscount > 0) {
      document.querySelectorAll('[data-discount-tag], [data-discount-tag-mobile]').forEach(el => {
        el.textContent = firstOrderDiscount + I18N.discountOffSuffix;
      });
    }

    const monthlyPricePerKid = monthlyPrice / currentNumKids;

    let quarterlyMonthlyPrice = basePrice;
    let quarterlyDiscount = 0;

    if (IS_UK && priceData.quarterlyPlanId) {
      const quarterlyAllocation = variant.sellingPlanAllocations.find(
        a => String(a.sellingPlanId) === String(priceData.quarterlyPlanId)
      );

      if (quarterlyAllocation) {
        quarterlyMonthlyPrice = quarterlyAllocation.price;

        if (basePrice > 0) {
          quarterlyDiscount = Math.round((1 - quarterlyMonthlyPrice / basePrice) * 100);
        }

        document.querySelectorAll('[data-discount-tag-quarterly], [data-discount-tag-quarterly-mobile]').forEach(el => {
          if (quarterlyDiscount > 0) {
            el.textContent = quarterlyDiscount + I18N.discountOffSuffix;
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      }
    }

    const quarterlyMonthlyPerKid = quarterlyMonthlyPrice / currentNumKids;
    const quarterlyTotalPerKid = (quarterlyMonthlyPrice * 3) / currentNumKids;
    const kidLabel = I18N.kidLabel;

    const priceElements = {
      'monthly': {
        display: formatPrice(monthlyPricePerKid) + kidLabel,
        daily: formatPrice(monthlyPricePerKid / 30) + kidLabel
      },
      'compare-monthly': {
        display: formatPrice(pricePerKid) + kidLabel,
        daily: formatPrice(pricePerKid / 30) + kidLabel
      },
      'onetime': {
        display: formatPrice(pricePerKid) + kidLabel,
        daily: formatPrice(pricePerKid / 30) + kidLabel
      },
      'quarterly': {
        display: formatPrice(quarterlyMonthlyPerKid) + kidLabel,
        daily: formatPrice(quarterlyMonthlyPerKid / 30) + kidLabel
      },
      'compare-quarterly': {
        display: formatPrice(pricePerKid) + kidLabel,
        daily: formatPrice(pricePerKid / 30) + kidLabel
      },
      'quarterly-per-month': {
        display: formatPrice(quarterlyTotalPerKid) + kidLabel + I18N.quarterLabel,
        daily: ''
      }
    };

    document.querySelectorAll('[data-price-type]').forEach(el => {
      const prices = priceElements[el.dataset.priceType];
      if (prices) {
        el.dataset.total = prices.display;
        el.dataset.daily = prices.daily;
        const newText = toggle?.checked ? prices.daily : prices.display;
        el.classList.add('price-switch');
        setTimeout(() => {
          el.textContent = newText;
          el.classList.remove('price-switch');
        }, 125);
      }
    });

    updateTabUnits();
    updateButtons();
  }

  const animatePriceSwap = (el, txt) => {
    el.classList.add('price-switch');
    setTimeout(() => {
      el.textContent = txt;
      el.classList.remove('price-switch');
    }, 125);
  };

  const refreshUI = () => {
    const daily = toggle?.checked;
    document.querySelectorAll('[data-total]').forEach(el => {
      const txt = daily ? el.dataset.daily : el.dataset.total;
      if (txt) animatePriceSwap(el, txt);
    });
    if (labelSpan) labelSpan.textContent = daily ? I18N.dailyPrice : I18N.monthlyPrice;
  };

  if (toggle) toggle.addEventListener('change', refreshUI);

  if (!localStorage.getItem('subsTabsRevealed')) {
    document.querySelectorAll('.subscription-tab').forEach((tab, i) => {
      tab.classList.add('reveal');
      setTimeout(() => tab.classList.remove('reveal'), 150 + i * 120);
    });
    localStorage.setItem('subsTabsRevealed', '1');
  }

  const updateDeliveryMessage = () => {
    const active = document.querySelector('.subscription-tab.is-active');
    if (!active) return;
    const msg = (active.dataset.msg || '').trim();
    if (msg === '') {
      deliveryMsg.style.display = 'none';
    } else {
      deliveryMsgTx.textContent = msg;
      deliveryMsg.style.display = 'flex';
    }
  };

  const updateButtons = () => {
    const active = document.querySelector('.subscription-tab.is-active');
    if (!active) return;

    if (nativeAdd) nativeAdd.style.display = 'none';
    if (paymentButton) paymentButton.style.display = 'none';

    customAdd.textContent = I18N.tryNow;
    customAdd.style.display = '';

    if (hiddenSP) hiddenSP.value = active.dataset.plan || '';

    updateDeliveryMessage();
  };

  document.querySelectorAll('.subscription-tab').forEach(tab => {
    tab.addEventListener('click', evt => {
      evt.preventDefault();
      document.querySelectorAll('.subscription-tab').forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      updateButtons();
    });
  });

  document.addEventListener('variant:changed', e => {
    const variantId = e.detail.variantId;

    document.querySelectorAll('.subscription-tab').forEach(tab => {
      tab.dataset.variant = variantId;
    });

    const variant = priceData.variants.find(v => String(v.id) === String(variantId));
    if (variant && variant.sellingPlanAllocations.length > 0) {
      let monthlyAlloc = variant.sellingPlanAllocations.find(
        a => String(a.sellingPlanId) === String(priceData.monthlyPlanId)
      ) || variant.sellingPlanAllocations[0];

      if (monthlyAlloc) {
        const subTabMonthly = document.querySelector('.subscription-tab.has-discount:not([data-plan-type="quarterly"])');
        if (subTabMonthly) subTabMonthly.dataset.plan = monthlyAlloc.sellingPlanId;
      }

      if (IS_UK && priceData.quarterlyPlanId) {
        const quarterlyAlloc = variant.sellingPlanAllocations.find(
          a => String(a.sellingPlanId) === String(priceData.quarterlyPlanId)
        );
        if (quarterlyAlloc) {
          const subTabQuarterly = document.querySelector('.subscription-tab[data-plan-type="quarterly"]');
          if (subTabQuarterly) subTabQuarterly.dataset.plan = quarterlyAlloc.sellingPlanId;
        }
      }
    }

    updateAllPrices(variantId);
  });

  const initializePrices = () => {
    let initialVariantId = null;
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) initialVariantId = variantInput.value;

    if (!initialVariantId) {
      const firstTab = document.querySelector('.subscription-tab');
      if (firstTab && firstTab.dataset.variant) initialVariantId = firstTab.dataset.variant;
    }

    if (!initialVariantId) {
      const firstAvailable = priceData.variants.find(v => v.available);
      if (firstAvailable) initialVariantId = firstAvailable.id;
    }

    if (initialVariantId) updateAllPrices(initialVariantId);
  };

  initializePrices();
  updateButtons();

  try {
    new MutationObserver(() => {
      if (currentVariantId) updateAllPrices(currentVariantId);
    }).observe(document.documentElement, { attributeFilter: ['lang'] });
  } catch (e) {}

  customAdd.addEventListener('click', () => {
    const active = document.querySelector('.subscription-tab.is-active');
    if (!active) return;

    const variantId = active.dataset.variant;
    const sellingPlan = active.dataset.plan || '';
    const isQuarterly = active.dataset.planType === 'quarterly';

    let qty = parseInt(active.dataset.units || '1', 10) || 1;

    if (isQuarterly) {
      qty = getQuarterlyCartUnits();
    }

    if (!sellingPlan) {
      const qtyInput = document.querySelector('input[name="quantity"]');
      if (qtyInput) qty = parseInt(qtyInput.value, 10) || 1;
    }

    const data = { id: variantId, quantity: qty };
    if (sellingPlan) data.selling_plan = sellingPlan;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(r => r.ok ? r.json() : r.json().then(e => { throw e; }))
      .then(() => {
        window.location = '/checkout';
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        if (error.description && error.description.includes('selling plan')) {
          alert(I18N.alertSubscriptionRequired);
        }
      });
  });
});